import * as React from 'react';
import ArrowExpandOutlined from './arrow-expand-outlined';
import ArrowExpandFilled from './arrow-expand-filled';
import type { IconCombinedProps } from './types';
const ArrowExpandCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <ArrowExpandFilled ref={ref} {...rest} />;
  }
  return <ArrowExpandOutlined ref={ref} {...rest} />;
});
export default ArrowExpandCombined;